import { render, staticRenderFns } from "./InactiveScannerCard.vue?vue&type=template&id=772bae84&scoped=true"
var script = {}
import style0 from "./InactiveScannerCard.vue?vue&type=style&index=0&id=772bae84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772bae84",
  null
  
)

export default component.exports